<template>
  <v-layout wrap align-top>
    <template v-for="({ value: field, text }, index) in headers">
      <template v-if="isNotEmpty(trial[field])">
        <v-flex
          class="primary lighten-3 text-uppercase font-weight-bold pa-2"
          :key="`title_${field}`"
          xs4
          md3
        >
          <small>{{ text }}</small>
        </v-flex>
        <v-flex
          class="font-weight-bold pa-2"
          :key="`content_${field}`"
          xs8
          md9
        >
          <template v-if="typeof trial[field] === 'object'">
            <template v-if="Array.isArray(trial[field])">
              <ul>
                <li v-for="(value, index) in trial[field]" :key="index">
                  <template v-if="typeof value === 'object'">
                    <small>{{ value.name || value.title }}</small>
                  </template>
                  <template v-else>
                    <small>{{ value }}</small>
                  </template>
                </li>
              </ul>
            </template>
            <template v-else>
              <template v-if="field.includes('date')">
                <small v-if="trial[field].from.value === trial[field].to.value">{{ trial[field].from.value }}</small>
                <small v-else>{{ trial[field].from.value }} - {{ trial[field].to.value }}</small>
              </template>
              <template v-else>
                <small>{{ trial[field].name || trial[field].title || trial[field].username }}</small>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-if="field === 'date_created'">
              <small>{{ new Date(trial[field]).toLocaleDateString('ru').split('.').reverse().join('-') }} {{ new Date(trial[field]).toLocaleTimeString().slice(0, 5) }}</small>
            </template>
            <template v-else-if="field === 'status'">
              <small>{{ trial[field].replace(/\_/g, ' ') }}</small>
            </template>
            <template v-else-if="field === 'id'">
              <small>{{ trial[field] }}</small>
            </template>
            <template v-else>
              <small>{{ trial[field] }}</small>
            </template>
          </template>
        </v-flex>
        <v-flex
          class="ma-0 pa-0"
          :key="`divider_${field}`"
          v-if="index !== headers.length - 1"
          xs12
        >
          <v-divider class="ma-0 pa-0"/>
        </v-flex>
      </template>
    </template>
  </v-layout>
</template>
<script>
import { CONST } from '@/utils';

const { trial: { headers } } = CONST;

export default {
  name: 'simpleGeneral',
  props: {
    trial: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      headers,
    };
  },
  methods: {
    isNotEmpty(value) {
      switch (true) {
        case typeof value === 'string':
          return value.length;
        case Array.isArray(value):
          return value.length;
        case typeof value === 'object':
          return Object.keys(value).length;
        default:
          return true;
      }
    },
  },
};
</script>
